import ApiRoutes from "../../http/routes";
import Http from "../../http/http";
import HttpRequest from "../../http/httpRequest";

export interface SaleMetrics {
  metrics: {
    enterpriseId: number;
    enterpriseName: string;
    period: string;
    enterprisesCount: number | null;
    correspondents: number;
    leads: number;
    scheduledVisits: {
      total: number;
      completed: number;
      pending: number;
    };
    detailedMetrics: {
      vgv: {
        totalValue: number;
        targetValue: number;
        totalSoldValue: number;
        totalSoldPercentage: number;
        totalUnits: number;
        totalSoldUnits: number;
        totalSoldUnitsPercentage: number;
      };
      periodDetails: Array<{
        label: string;
        soldValue: number;
        soldUnits: number;
        soldPercentage: number;
        periodType: string;
      }>;
    };
  };
}

export default class MetricsRepository {
  private static instance: MetricsRepository | null = null;

  constructor(private http: Http) {}

  static getInstance(http: Http): MetricsRepository {
    if (!MetricsRepository.instance) {
      MetricsRepository.instance = new MetricsRepository(http);
    }
    return MetricsRepository.instance;
  }

  async getSaleMetrics(params: {
    enterpriseId?: number;
    fromDate?: number;
    toDate?: number;
    periodType?: "year" | "month" | "week";
  }): Promise<SaleMetrics> {
    const queryParams = new URLSearchParams();

    if (params.enterpriseId) {
      queryParams.append("enterpriseId", params.enterpriseId.toString());
    }
    if (params.fromDate) {
      queryParams.append("fromDate", params.fromDate.toString());
    }
    if (params.toDate) {
      queryParams.append("toDate", params.toDate.toString());
    }
    if (params.periodType) {
      queryParams.append("periodType", params.periodType);
    }

    const request = new HttpRequest(
      `${ApiRoutes.dashboard}/sale-metrics`,
      null,
      queryParams
    );

    return await this.http.get<SaleMetrics>(request);
  }
}
